query PaymentSearchFilterTotals(
 $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $searchRequest: SearchRequestInput
  $isLinkSearch: Boolean
  $filterBusinessUnitId: UUID
$filterCompanyId: UUID
$filterCurrencyId: Int
$filterStatusTypeId: Int
$filterTransactionTypeId: Int
) {
    paymentSearchFilterTotals(
    isHistorySearch: $isHistorySearch
    isLinkSearch: $isLinkSearch
    isSigningSearch: $isSigningSearch
    searchRequest: $searchRequest
    filterBusinessUnitId: $filterBusinessUnitId
    filterCompanyId: $filterCompanyId
    filterCurrencyId: $filterCurrencyId
    filterStatusTypeId: $filterStatusTypeId
    filterTransactionTypeId: $filterTransactionTypeId
  ) {
    totalAmount1
    totalAmount2
    totalAmount3
    totalCount1
  }
}